import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

const KioskCheckoutContent = styled(Box)(({ theme }) => ({
  width: '75%',
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '12px',
  padding: theme.spacing(4, 10),

  [theme.breakpoints.down('md')]: {
    width: '100%',
    padding: theme.spacing(4, 10),
  },
}));

export default KioskCheckoutContent;